import { instance } from "libs/api";

import { ApiRoutesProducts } from "./../../constants";
import {
  CreateProductRequestBody,
  CreateProductResponseData
} from "./createProduct.types";

export const requestCreateProduct = async (
  body: CreateProductRequestBody
): Promise<CreateProductResponseData> => {
  return await instance.post(ApiRoutesProducts.Product, body);
};
